import React from 'react';
import { Controller } from 'react-hook-form';
import _get from 'lodash/get';
import Checkbox from '../baseui/input/checkbox';

interface ICheckboxInputProps {
	name: any;
	control: any;
	disabled: boolean;
	defaultValue: any;
}

const CheckboxInput: React.FC<ICheckboxInputProps> = (props) => {
	const { name, control, disabled, defaultValue } = props;

	return (
		<Controller
			render={({ field: { onChange, value } }) => <Checkbox checked={value} onChange={onChange} disabled={disabled} />}
			control={control}
			name={name}
			defaultValue={defaultValue && _get(defaultValue, ['field', ...defaultValue.path])}
		/>
	);
};

export default CheckboxInput;
